import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import DragIndicatorRoundedIcon from '@material-ui/icons/DragIndicatorRounded';
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import Grid from "@material-ui/core/Grid/Grid";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction
} from "@material-ui/core";
import RootRef from "@material-ui/core/RootRef";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {setStore} from "trim-redux";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import MakeMenuItem from "./MakeMenuItem";
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
    // styles we need to apply on draggables
    ...draggableStyle,

    ...(isDragging && {
        background: "rgb(235,235,235)",

    })
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#fbfbfb' : null,
    borderRadius:10,
    padding:10
});

class MenuChooser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menus: null,
            loading: true,
            dragLoading: false,
        };
        this.onDragEnd = this.onDragEnd.bind(this);
    }
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let {position} = this.props;
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/menus/getByType/${position}`, config)
                .then(response => {
                    this.setState({
                        menus:response.data,
                        loading:false
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    async onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        await  this.setState({
            dragLoading:true
        })

        let source = this.state.menus[result.source.index];
        let destination = this.state.menus[result.destination.index];
        const menus = reorder(
            this.state.menus,
            result.source.index,
            result.destination.index
        );
        this.setState({
            menus
        });
        let loginToken = localStorage.getItem('ACT');
        let data = new FormData();
        data.append('source', source.id);
        data.append('destination', destination.id);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/menus/changeOrder`,data, config)
                .then(response => {
                    this.setState({
                        dragLoading:false
                    });
                }).catch(error => {
                    console.log(error.response)
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }

    }
    async handleRemoveMenuItem(id) {
        await  this.setState({
            dragLoading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let data = new FormData();
        data.append('id',id);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/menus/remove-item`,data, config)
                .then(async response => {
                    await this.loadData()
                    await this.setState({
                        dragLoading:false
                    });
                }).catch(error => {
                    console.log(error.response)
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }

    }
    classes = this.props.classes;
    render(){
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderFields/> :
                        <Grid container spacing={2} justify="center" alignItems="center">
                            <Grid item xs={12}>
                                {
                                    this.state.dragLoading ?
                                        <LinearProgress />
                                        : null
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided, snapshot) => (
                                            <RootRef rootRef={provided.innerRef}>
                                                <List style={getListStyle(snapshot.isDraggingOver)}>
                                                    {this.state.menus.map((item, index) => (
                                                        <Draggable key={"item-"+item.id} draggableId={"item-"+item.id} index={index}>
                                                            {(provided, snapshot) => (
                                                                <ListItem
                                                                    className="draggable_list_item"
                                                                    ContainerComponent="li"
                                                                    ContainerProps={{ ref: provided.innerRef }}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={getItemStyle(
                                                                        snapshot.isDragging,
                                                                        provided.draggableProps.style
                                                                    )}
                                                                >
                                                                    <ListItemIcon>
                                                                        <DragIndicatorRoundedIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={item.name}
                                                                        secondary={`${item.url}`}
                                                                    />
                                                                    <MakeMenuItem
                                                                        position={this.props.position}
                                                                        item={item}
                                                                        reload={() => this.loadData()}
                                                                    />
                                                                    <IconButton
                                                                        onClick={ () => this.handleRemoveMenuItem(item.id)}
                                                                    >
                                                                        <CloseRoundedIcon fontSize="small"/>
                                                                    </IconButton>
                                                                    <ListItemSecondaryAction>
                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </List>
                                            </RootRef>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </Grid>
                            <Grid item xs={12} style={{textAlign:"center",marginBottom:30}}>
                                <MakeMenuItem
                                    position={this.props.position}
                                    reload={() => this.loadData()}
                                />
                            </Grid>
                        </Grid>
                }
            </>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(MenuChooser)));